import * as components from './components';
import * as directives from './directives';
import { vueUse } from './utils';

/* eslint-disable no-var, no-undef, guard-for-in, object-shorthand */

var VuePlugin = {
  install: function install(Vue) {
    if (Vue._bootstrap_vue_installed) {
      return;
    }

    Vue._bootstrap_vue_installed = true;

    // Register component plugins
    for (var plugin in components) {
      Vue.use(components[plugin]);
    }

    // Register directive plugins
    for (var _plugin in directives) {
      Vue.use(directives[_plugin]);
    }
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/index.js
// module id = 323
// module chunks = 0